import { CHANGE_FOOTER_STATUS } from "./actionTypes";

export default (status) => ({
  type: CHANGE_FOOTER_STATUS,
  payload: {
    status // true or false
  },
});